import React, { Component, useEffect, useState } from 'react';

/**
 * @param {{children: Component, title?: string, icon?: Component, spacingOverride?: number}} param0
 * @returns
 */
export default function DataGridDisplay({ className, children, title, icon, spacingOverride = 0 }) {
  return (
    <div className={'flex-grow-1 ' + className}>
      <div className="d-flex justify-content-between border-bottom">
        <div>{title}</div>
        <div>{icon}</div>
      </div>
      <div>{children}</div>
    </div>
  );
}
